//Tirar bin/console fos:js-routing:dump --format=json --target=js_es6/fos_js_routes.json para actualizar las rutas
import {LOADER_HTML} from "../topbottom/utils";
const routes = require('../../fos_js_routes.json');
import Routing from '../../../vendor/friendsofsymfony/jsrouting-bundle/Resources/public/js/router'
import {dispatchLazyEvent} from "../media/images";


let routeName, pageCount, query, pageNameParameter, element, page = 1, is_processing = false, has_finished = false;

const loadMoreElements = () => {
    is_processing = true;
    page++;
    const url = Routing.generate(routeName, {...query, [pageNameParameter]: page});

    element.innerHTML = LOADER_HTML;
    fetch(url, {
        method: 'GET',
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        }
    })
        .then(response => response.text())
        .then(response => {
            has_finished = !(page < pageCount)
            element.insertAdjacentHTML("beforebegin", response);
            dispatchLazyEvent();
        })
        .catch(err => {
            has_finished = true;
            element.innerHTML = '<div class="error">No ha sido posible cargar más noticias.</div>'
        })
        .finally(() => {
            is_processing = false;
            if (has_finished) {
                element.parentNode.removeChild(element);
                has_finished = true;
            }
        })

}

/**
 *
 * @param {HTMLElement} moreElement Píxel que contiene la información de rutas y configuración
 *  y que hará de testigo en el viewport para activar el evento de carga.
 * @returns {Promise<void>}
 */
export const infiniteScroller = async (moreElement) => {
    element = moreElement;

    Routing.setRoutingData(routes);
    //Definir algunos parámetros que vienen de Twig
    routeName = element.dataset.infiscrollRoute;
    pageCount = parseInt(element.dataset.infiscrollCount);
    query = JSON.parse(element.dataset.infiscrollQuery);
    pageNameParameter = element.dataset.infiscrollPageparameter;
    console.log(routeName, pageCount, query, pageNameParameter);

    //Alto del viewport y desplazamiento
    const viewportHeight = (window.innerHeight || document.documentElement.clientHeight);
    const threshold = 180;
    window.addEventListener('scroll', () => {
        if (has_finished || is_processing) {
            return;
        }
        requestAnimationFrame(() => {
            const elemYPos = element.getBoundingClientRect().y;
            if(!is_processing && elemYPos - viewportHeight - threshold <= 0) {
                loadMoreElements();
            }
        })
    }, true);
}
